const getters = {
    departments: (state) => state.departments,
    departmentId: (state) => state.departmentId,
    loading: state => state.loading
};

export default getters;